import {
    apiFetchConfiguration,
    apiUpdateConfiguration
} from '../../api/onboarding.js'
import {
    apiFetchGcsObject
} from '../../api/global.js'
import * as constant from './constant'
export const actions = {
    async fetchConfiguration({ commit, state }) {
        if (!state.userConfiguration.lineid) return false
        const rs = await apiFetchConfiguration(state.userConfiguration.lineid);
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data !== 'Line ID is Not Found') {
                await commit(constant.ONBOARDING_USER_SETTING, data)
            } else console.log(`${data}: ${state.userConfiguration.lineid}`);
        }
    },
    async fetchGlobalConfiguration({ commit }, objectPath) {
        const rs = await apiFetchGcsObject(objectPath);
        if (rs && rs.status == 200) {
            let data = rs.data
            await commit(constant.ONBOARDING_GLOBAL_USER_SETTING, data)
        }
    },
    async insertConfiguration({ state }) {
        try {
            if (!state.userConfiguration.lineid) return false
            const rs = await apiUpdateConfiguration(state.userConfiguration);
            if (rs && rs.status == 200) return true
            else return false
        } catch (error) {
            throw new Error(error)
        }
    }
}